/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsWithSubmissionsData } from '../../models/submissions-with-submissions-data';

export interface GetSubmissionApiV2SubmissionsOrgIdGet$Params {
  id: string;
  org: string;
}

export function getSubmissionApiV2SubmissionsOrgIdGet(http: HttpClient, rootUrl: string, params: GetSubmissionApiV2SubmissionsOrgIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsWithSubmissionsData>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionApiV2SubmissionsOrgIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsWithSubmissionsData>;
    })
  );
}

getSubmissionApiV2SubmissionsOrgIdGet.PATH = '/api/v2/submissions/{org}/{id}';
